"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KcApp = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Login_1 = require("./Login");
var Register_1 = require("./Register");
var RegisterUserProfile_1 = require("./RegisterUserProfile");
var Info_1 = require("./Info");
var Error_1 = require("./Error");
var LoginResetPassword_1 = require("./LoginResetPassword");
var LoginVerifyEmail_1 = require("./LoginVerifyEmail");
var Terms_1 = require("./Terms");
var LoginOtp_1 = require("./LoginOtp");
var LoginUpdatePassword_1 = require("./LoginUpdatePassword");
var LoginUpdateProfile_1 = require("./LoginUpdateProfile");
var LoginIdpLinkConfirm_1 = require("./LoginIdpLinkConfirm");
var LoginPageExpired_1 = require("./LoginPageExpired");
var LoginIdpLinkEmail_1 = require("./LoginIdpLinkEmail");
var LoginConfigTotp_1 = require("./LoginConfigTotp");
var LogoutConfirm_1 = require("./LogoutConfirm");
exports.KcApp = (0, react_1.memo)(function (_a) {
    var kcContext = _a.kcContext, props = __rest(_a, ["kcContext"]);
    switch (kcContext.pageId) {
        case "login.ftl":
            return (0, jsx_runtime_1.jsx)(Login_1.Login, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "register.ftl":
            return (0, jsx_runtime_1.jsx)(Register_1.Register, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "register-user-profile.ftl":
            return (0, jsx_runtime_1.jsx)(RegisterUserProfile_1.RegisterUserProfile, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "info.ftl":
            return (0, jsx_runtime_1.jsx)(Info_1.Info, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "error.ftl":
            return (0, jsx_runtime_1.jsx)(Error_1.Error, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-reset-password.ftl":
            return (0, jsx_runtime_1.jsx)(LoginResetPassword_1.LoginResetPassword, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-verify-email.ftl":
            return (0, jsx_runtime_1.jsx)(LoginVerifyEmail_1.LoginVerifyEmail, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "terms.ftl":
            return (0, jsx_runtime_1.jsx)(Terms_1.Terms, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-otp.ftl":
            return (0, jsx_runtime_1.jsx)(LoginOtp_1.LoginOtp, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-update-password.ftl":
            return (0, jsx_runtime_1.jsx)(LoginUpdatePassword_1.LoginUpdatePassword, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-update-profile.ftl":
            return (0, jsx_runtime_1.jsx)(LoginUpdateProfile_1.LoginUpdateProfile, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-idp-link-confirm.ftl":
            return (0, jsx_runtime_1.jsx)(LoginIdpLinkConfirm_1.LoginIdpLinkConfirm, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-idp-link-email.ftl":
            return (0, jsx_runtime_1.jsx)(LoginIdpLinkEmail_1.LoginIdpLinkEmail, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-page-expired.ftl":
            return (0, jsx_runtime_1.jsx)(LoginPageExpired_1.LoginPageExpired, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "login-config-totp.ftl":
            return (0, jsx_runtime_1.jsx)(LoginConfigTotp_1.LoginConfigTotp, __assign({}, __assign({ kcContext: kcContext }, props)));
        case "logout-confirm.ftl":
            return (0, jsx_runtime_1.jsx)(LogoutConfirm_1.LogoutConfirm, __assign({}, __assign({ kcContext: kcContext }, props)));
    }
});
//# sourceMappingURL=KcApp.js.map